module.exports = __webpack_public_path__ + "static/failure-582233241c070302707a484dd219ae3c.mp4";